import script from "./SidebarMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarMenu.vue?vue&type=script&setup=true&lang=ts"

import "./SidebarMenu.vue?vue&type=style&index=0&id=6cf7b59c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cf7b59c"]])

export default __exports__